import { RequestPhaseAsyncMultiValuedList } from '../../../Request'
import { ListCell } from '../ListCell'

function PhasesListCell({
  List = RequestPhaseAsyncMultiValuedList,
  id,
  ...restProps
}) {
  return <ListCell {...restProps} List={List} listProps={{ id }} />
}

export default PhasesListCell
